const {
  REACT_APP_ENV, REACT_APP_DNS_API_DASH
} = process.env


export const ENV = REACT_APP_ENV

export const DNS_DASH_API = REACT_APP_DNS_API_DASH